import React from 'react';
import styles from './styles.module.css';

const Scheme = ({ scheme }) => (
  <>
    {scheme && (
      <div className={styles.root}>
        <h3 className={styles.title}>Схема обучения</h3>
        <ul className={styles.list}>
          {scheme.map((item, i) => (
            <li key={i}>
              <span className={styles.subTitle}>{item.title}</span>
              <p className={styles.smallText}>{item.desc}</p>
            </li>
          ))}
        </ul>
      </div>
    )}
  </>
);

export default Scheme;
